var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.41 37.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.28,13.06a1,1,0,1,0,1,1A1,1,0,0,0,23.28,13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.16,9.86H15.25A5.23,5.23,0,0,0,10,15.09V22a5.24,5.24,0,0,0,5.24,5.24h6.91A5.25,5.25,0,0,0,27.4,22V15.09A5.24,5.24,0,0,0,22.16,9.86ZM25.76,22a3.6,3.6,0,0,1-3.6,3.6H15.25a3.6,3.6,0,0,1-3.6-3.6V15.09a3.6,3.6,0,0,1,3.6-3.59h6.91a3.6,3.6,0,0,1,3.6,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.7,14.26A4.3,4.3,0,1,0,23,18.55,4.3,4.3,0,0,0,18.7,14.26Zm0,7a2.75,2.75,0,1,1,2.75-2.75A2.75,2.75,0,0,1,18.7,21.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.25,
    y: 0.25,
    width: 36.91,
    height: 36.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.7b42f608e880e8e266b9bc30322924a4.svg";
export { ForwardRef as ReactComponent };